
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
// import PaymentRequestBar from "../../components/PaymentRequest/PaymentRequestBar";
import PaymentRequestTable from "../../components/PaymentRequest/PaymentRequestTable";
import Pagination from "../../components/shared/Pagination";

const PaymentRequestsHomePage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle('أوامر الدفع');
    const [userData, setUserData] = useState(null);
    const pageTitle = {title: 'أوامر الدفع', subTitle: 'يمكنك متابعة أوامر الدفع من هنا.'};
    const [paymentRequests, setPaymentRequests] = useState(null);

    const [pageSize, setPageSize] = useState(20);
    const [currentPage,setCurrentPage] = useState(1);
    const [total,setTotal] = useState(0);

    const handleGetUser = (user) => {
        setUserData(user);
    }

    const getPaymentRequests = async (page=1) => {
      try {
        const response = await apiClient.get(`/b-payment-requests?skip=${(page-1)*pageSize}&limit=${pageSize}`);
        if(response?.data) {
          setPaymentRequests(response?.data?.data);
          setTotal(response?.data?.total);
          setCurrentPage(page);
        // setPaymentRequests([])
        }
      } catch(err) {}
    }

    const handleChangePageAction = (page) =>{
        getPaymentRequests(page);
    }

    useEffect(()=>{
        getPaymentRequests();
    },[]);


    return (
        <div>
            <PageHeader pageTitle={pageTitle} userCallback={handleGetUser} />
            <PageMain>
                <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
                <MainContent>
                    {/* <PaymentRequestBar paymentRequestCount={paymentRequests?.length} /> */}
                    {/* no notification view */}
                    {paymentRequests !== null && Array.isArray(paymentRequests) && paymentRequests?.length < 1 && 
                        <div className="pt-[80px] text-center">
                        <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/receipt.svg')"}}></div>
                        <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لا توجد أي أوامر دفع حتي الأن</div>
                        {/* <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to="/ar/payment-requests/add">أضف تنبيه جديد</Link> */}
                        </div>
                    }
                    {/* notification view */}
                    {paymentRequests !== null && Array.isArray(paymentRequests) && paymentRequests?.length > 0 && 
                        <div className="pt-[25px]">
                            <PaymentRequestTable paymentRequests={paymentRequests} currentPage={currentPage} pageSize={pageSize} />
                            <Pagination label={'أمر دفع'} total={total} currentPage={currentPage} pageSize={pageSize} handleClickChangePage={page => handleChangePageAction(page)} />
                        </div>
                    }
                </MainContent>
            </PageMain>
        </div>
    )

}
export default PaymentRequestsHomePage;